import { tv } from "tailwind-variants";

export const tooltipOffsetForArrow = 4; // Arrow "depth" is half of size-2

export const tooltipStyle = tv({
  slots: {
    tooltip:
      "group/tooltip pointer-events-none rounded-md bg-slate-900/90 text-gray-50 shadow-xs transition data-[entering]:scale-95 data-[entering]:opacity-0 data-[entering]:duration-150 data-[exiting]:scale-95 data-[exiting]:opacity-0 data-[exiting]:duration-75 data-[placement=bottom]:translate-y-2 data-[placement=left]:-translate-x-2 data-[placement=right]:translate-x-2 data-[placement=top]:-translate-y-2",
    arrowSvg:
      "block size-2 fill-slate-900 group-data-[placement=bottom]/tooltip:rotate-180 group-data-[placement=left]/tooltip:-rotate-90 group-data-[placement=right]/tooltip:rotate-90",
    content: "max-w-xs px-2.5 py-2 text-sm",
  },
});
